import { render, staticRenderFns } from "./DateCard.vue?vue&type=template&id=2dfe0492&"
import script from "./DateCard.vue?vue&type=script&lang=js&"
export * from "./DateCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports